import { values } from 'lodash';

enum LossCodeSection {
  part = 'Part',
  labour = 'Labour',
  other = 'Other',
}

type TPartialPickLossCode<T extends keyof Model.ILossCode> = Partial<Pick<Model.ILossCode, T>>;
const sectionCodes: string[] = values(LossCodeSection);

export function filterLossCodesBySection<T extends TPartialPickLossCode<'sectionCode' | 'code'>>(
  lossCodes: T[],
  jobItemTypeCode: string,
  keepCode?: string
): T[] {
  if (!sectionCodes.includes(jobItemTypeCode)) return lossCodes;
  return lossCodes?.filter((it) => it.sectionCode === jobItemTypeCode || (!!keepCode && it.code === keepCode));
}

export function filterOutInternalLossCodes<T extends TPartialPickLossCode<'isInternalOnly'>>(
  lossCodes: T[],
  isInternalUser: boolean
): T[] {
  if (isInternalUser) return lossCodes;
  return lossCodes?.filter((it) => !it.isInternalOnly);
}

export function filterOutDisabledLossCodes<T extends TPartialPickLossCode<'isDisabled' | 'code'>>(
  lossCodes: T[],
  keepCode?: string
): T[] {
  return lossCodes?.filter((it) => !it.isDisabled || (!!keepCode && it.code === keepCode));
}

export default LossCodeSection;
